import React, { useEffect, useState } from "react";
import classes from "./FormBenefitsBox.module.scss";
import FormBenefitsBoxItem from "./FormBenefitsBoxItem/FormBenefitsBoxItem";

const orderBenefits = async (props) => {
  const _planName =
    props.sizeOfPlan === "ballPark" ? "eightyBallpark" : props.sizeOfPlan;

  const _styleOfPlan = await props.cms.filter(
    (b) => b.name.toLowerCase() === props.styleOfPlan
  );

  const _sizeOfPlan = await _styleOfPlan[0].plans.filter(
    (b) => b.sizePlanChoice === _planName
  );
  return _sizeOfPlan[0][`page${props.title}`];
};

const mapOrder = async (array, order) => {
  if (array && order) {
    const _orderedArr = [];

    await array.forEach((p) => {
      const benefitExist = order.filter((b) => {
        return b.name === p.label;
      });
      if (benefitExist.length > 0) {
        _orderedArr.push(p);
      }
    });
    await _orderedArr.sort(function (a, b) {
      const indexA = order.findIndex(function (entry) {
        return entry.name === a.label;
      });
      const indexB = order.findIndex(function (entry) {
        return entry.name === b.label;
      });
      if (indexA > indexB) {
        return 1;
      } else {
        return -1;
      }
    });
    return _orderedArr;
  }
};

const FormBenefitsBox = (props) => {
  const [correctOrder, setCorrectOrder] = useState();
  const [benefits, setBenefits] = useState();

  useEffect(() => {
    if (!correctOrder) {
      orderBenefits(props).then((res) => {
        setCorrectOrder(res);
      });
    }
    if (!benefits) {
      mapOrder(props.benefits, correctOrder).then((res) => {
        setBenefits(res);
      });
    }
  }, [props, correctOrder, benefits]);

  return (
    <div className={classes.FormBenefitsBox}>
      <div className={classes._FormBenefitsBox}>
        <div className={classes.title}>{props.title}</div>
        {benefits && (
          <FormBenefitsBoxItem
            benefits={benefits}
            sizeOfPlan={props.sizeOfPlan}
            styleOfPlan={props.styleOfPlan}
            category={props.category}
            benefitsItemHandler={props.benefitsItemHandler}
          />
        )}
      </div>
    </div>
  );
};

export default FormBenefitsBox;
